import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import PageHero from "@/components/PageHero";
import { Icon } from "@/lib/icons";
import { INDUSTRIES, img } from "@/config";

export default function Industries() {
  return (
    <div data-testid="industries-page">
      <PageHero
        eyebrow="Industries We Serve"
        titleLines={["Security tailored", "to your sector."]}
        subtitle="Every industry has unique risks and requirements. We design solutions that fit — from statewide government networks to single-store retail security."
        imageKey="networking"
      />

      <section className="mx-auto max-w-7xl px-6 py-16 lg:px-10 lg:py-20">
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {INDUSTRIES.map((ind, i) => (
            <Reveal key={ind.title} delay={(i % 3) * 0.08}>
              <motion.div whileHover={{ y: -6 }} data-testid={`industry-card-${ind.title.toLowerCase()}`} className="group relative h-full overflow-hidden rounded-3xl border border-slate-800">
                <div className="absolute inset-0">
                  <img src={img(ind.image)} alt={ind.title} className="h-full w-full object-cover opacity-25 transition-all duration-500 group-hover:scale-105 group-hover:opacity-35" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0B1120] via-[#0B1120]/85 to-[#0B1120]/60" />
                </div>
                <div className="relative flex h-full min-h-[280px] flex-col justify-end p-8">
                  <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#2563EB] text-white"><Icon name={ind.icon} className="h-6 w-6" /></span>
                  <h3 className="mt-5 font-display text-2xl font-bold tracking-tight text-white">{ind.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-300">{ind.body}</p>
                </div>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-6 pb-28 lg:px-10">
        <Reveal>
          <div className="flex flex-col items-start justify-between gap-6 rounded-[2rem] border border-slate-800 bg-[#111c33] p-10 lg:flex-row lg:items-center lg:p-14">
            <h2 className="max-w-xl font-display text-3xl font-extrabold tracking-tight text-white lg:text-4xl">Not sure which solution fits your sector?</h2>
            <Link to="/contact" data-testid="industries-cta-button" className="group inline-flex shrink-0 items-center gap-2 rounded-full bg-[#2563EB] px-7 py-4 text-base font-semibold text-white transition-colors hover:bg-[#3b82f6]">Talk to an expert <ArrowUpRight className="h-5 w-5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" /></Link>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
